var _desc, _style, _circle, _ellipse, _rect, _rect2, _rect3, _rect4, _g, _path, _path2, _g2, _g3, _g4, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyReportSections(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 200",
    width: 240,
    height: 200,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "empty-report-sections-title"
  }, "Raportissa ei ole viel\xE4 elementtej\xE4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "empty-report-sections-title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "empty-report-sections-desc"
  }, "Tyhj\xE4 raporttisivu pudotusalueineen sek\xE4 leijuvat taulukko- ja kaavioelementit")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .empty-report-sections-accent { fill: var(--empty-accent, #6366f1); }\n    .empty-report-sections-stroke { stroke: var(--empty-accent, #6366f1); }\n    .empty-report-sections-muted  { fill: var(--empty-muted, #e0e7ff); }\n    .empty-report-sections-surface{ fill: var(--empty-surface, #ffffff); }\n    .empty-report-sections-line   { stroke: var(--empty-line, #c7d2fe); }\n    .empty-report-sections-lfill  { fill: var(--empty-line, #c7d2fe); }\n    .empty-report-sections-plus   { animation: empty-report-sections-plus 2.4s ease-in-out 2; transform-origin: 104px 112px; }\n    @keyframes empty-report-sections-plus   { 0%,100% { transform: scale(1); } 50% { transform: scale(1.12); } }\n    @media (prefers-reduced-motion: reduce) { .empty-report-sections-plus { animation: none; } }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 104,
    r: 86,
    className: "empty-report-sections-muted",
    opacity: 0.55
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108,
    cy: 174,
    rx: 60,
    ry: 6,
    className: "empty-report-sections-accent",
    opacity: 0.12
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 34,
    width: 112,
    height: 136,
    rx: 8,
    className: "empty-report-sections-surface empty-report-sections-stroke",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 46,
    width: 44,
    height: 6,
    rx: 3,
    className: "empty-report-sections-accent",
    opacity: 0.45
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 57,
    width: 28,
    height: 4,
    rx: 2,
    className: "empty-report-sections-lfill"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "empty-report-sections-line empty-report-sections-zone",
    x: 60,
    y: 70,
    width: 88,
    height: 84,
    rx: 7,
    fill: "none",
    strokeWidth: 2,
    strokeDasharray: "6 2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "empty-report-sections-plus"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 112,
    r: 13,
    className: "empty-report-sections-accent",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 105,
    x2: 104,
    y2: 119,
    className: "empty-report-sections-stroke",
    strokeWidth: 2.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97,
    y1: 112,
    x2: 111,
    y2: 112,
    className: "empty-report-sections-stroke",
    strokeWidth: 2.8,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "empty-report-sections-stroke empty-report-sections-arrow",
    d: "M172 84 C160 90 150 98 132 104",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "3 5",
    opacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136 98 L130 105 L139 107",
    fill: "none",
    className: "empty-report-sections-stroke",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.55
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "empty-report-sections-floatA"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 44,
    width: 50,
    height: 40,
    rx: 7,
    className: "empty-report-sections-surface empty-report-sections-stroke",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 52,
    width: 34,
    height: 8,
    rx: 2,
    className: "empty-report-sections-accent",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 60 V76 H208 V60 M174 68 H208 M185 60 V76 M197 60 V76",
    fill: "none",
    className: "empty-report-sections-line",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "empty-report-sections-floatB"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 104,
    width: 46,
    height: 40,
    rx: 7,
    className: "empty-report-sections-surface empty-report-sections-stroke",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 136,
    x2: 210,
    y2: 136,
    className: "empty-report-sections-line",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 122,
    width: 6,
    height: 12,
    rx: 1.5,
    className: "empty-report-sections-accent",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 114,
    width: 6,
    height: 20,
    rx: 1.5,
    className: "empty-report-sections-accent",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201,
    y: 118,
    width: 6,
    height: 16,
    rx: 1.5,
    className: "empty-report-sections-accent",
    opacity: 0.55
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "empty-report-sections-floatA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204 72 L204 92 L209 87 L213 96 L217 94 L213 85 L220 85 Z",
    className: "empty-report-sections-surface empty-report-sections-stroke",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 70,
    r: 3,
    className: "empty-report-sections-accent",
    opacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 140,
    r: 2.5,
    className: "empty-report-sections-accent",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyReportSections);
export default __webpack_public_path__ + "static/media/empty-report-sections.762b551f5bc2c0cf3c3953ccfe8fc5a7.svg";
export { ForwardRef as ReactComponent };